import {
  aeLocales,
  bdLocales,
  indLocales,
  trLocales,
} from '@porterin/component-library/src/ts-utils/analytics/constants/LocaleConstants';

export enum Countries {
  BD = 'bd',
  AE = 'ae',
  UAE = 'uae',
  TR = 'tr',
  IND = 'ind',
}

Object.freeze(Countries);

export enum GACountries {
  BD = 'BD',
  UAE = 'UAE',
  TR = 'TR',
  IND = 'IND',
}

Object.freeze(GACountries);

export interface CountryLocales {
  country: Countries;
  locales: string[];
}

export const countries: CountryLocales[] = [
  { country: Countries.BD, locales: bdLocales },
  { country: Countries.AE, locales: aeLocales },
  { country: Countries.TR, locales: trLocales },
  { country: Countries.IND, locales: indLocales },
];
